/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Consumer_Declaration_Review_IntroInputs */

const en_consumer_declaration_review_intro = /** @type {(inputs: Consumer_Declaration_Review_IntroInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Check the declaration below. It is not sent until you use the final button.`)
};

const de_consumer_declaration_review_intro = /** @type {(inputs: Consumer_Declaration_Review_IntroInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Prüfen Sie die Erklärung. Sie wird erst über die abschließende Schaltfläche abgesendet.`)
};

const fr_consumer_declaration_review_intro = /** @type {(inputs: Consumer_Declaration_Review_IntroInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Vérifiez la déclaration. Elle n’est envoyée qu’avec le bouton final.`)
};

const es_consumer_declaration_review_intro = /** @type {(inputs: Consumer_Declaration_Review_IntroInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Revisa la declaración. No se enviará hasta usar el botón final.`)
};

const it_consumer_declaration_review_intro = /** @type {(inputs: Consumer_Declaration_Review_IntroInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Controlla la dichiarazione. Verrà inviata solo con il pulsante finale.`)
};

const nl_consumer_declaration_review_intro = /** @type {(inputs: Consumer_Declaration_Review_IntroInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Controleer de verklaring. Ze wordt pas met de laatste knop verzonden.`)
};

const pl_consumer_declaration_review_intro = /** @type {(inputs: Consumer_Declaration_Review_IntroInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sprawdź oświadczenie. Zostanie wysłane dopiero ostatnim przyciskiem.`)
};

const fi_consumer_declaration_review_intro = /** @type {(inputs: Consumer_Declaration_Review_IntroInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tarkista ilmoitus. Se lähetetään vasta viimeisellä painikkeella.`)
};

const da_consumer_declaration_review_intro = /** @type {(inputs: Consumer_Declaration_Review_IntroInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Kontrollér erklæringen. Den sendes først med den sidste knap.`)
};

const sv_consumer_declaration_review_intro = /** @type {(inputs: Consumer_Declaration_Review_IntroInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Kontrollera förklaringen. Den skickas först med den sista knappen.`)
};

/**
* | output |
* | --- |
* | "Check the declaration below. It is not sent until you use the final button." |
*
* @param {Consumer_Declaration_Review_IntroInputs} inputs
* @param {{ locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }} options
* @returns {LocalizedString}
*/
export const consumer_declaration_review_intro = /** @type {((inputs?: Consumer_Declaration_Review_IntroInputs, options?: { locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Consumer_Declaration_Review_IntroInputs, { locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return de_consumer_declaration_review_intro(inputs)
	if (locale === "fr") return fr_consumer_declaration_review_intro(inputs)
	if (locale === "es") return es_consumer_declaration_review_intro(inputs)
	if (locale === "it") return it_consumer_declaration_review_intro(inputs)
	if (locale === "nl") return nl_consumer_declaration_review_intro(inputs)
	if (locale === "pl") return pl_consumer_declaration_review_intro(inputs)
	if (locale === "fi") return fi_consumer_declaration_review_intro(inputs)
	if (locale === "da") return da_consumer_declaration_review_intro(inputs)
	if (locale === "sv") return sv_consumer_declaration_review_intro(inputs)
	return en_consumer_declaration_review_intro(inputs)
});